import { Site } from '../site';

$('.side-navigation').on('update.zf.magellan', function(e) {
  var element = document.querySelector('.side-navigation__link--active');
  if(!!element) {
    $('.side-navigation').stop().animate({
      scrollTop: element.offsetTop
    }, 400);
  }
});

Site.initializeFoundation();